var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("wistia_channel wistia_async_" + _vm.videoId + " mode=inline"),staticStyle:{"min-height":"100vh","position":"relative","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }